// extracted by mini-css-extract-plugin
export var acceptButton = "_28-5";
export var fullContent = "_28-4";
export var link = "_28-6";
export var linkIcon = "_28-7";
export var sideContent = "_28-3";
export var sideImage = "_28-2";
export var sideImageWrapper = "_28-1";
export var splitLayout = "_28-0";